document.addEventListener('variant:change', function(event) {
  let selectedVariant = event.detail.variant.id;
  let selectedVariantMessage = $(event.target).find('[variant-id="' + selectedVariant + '"]').attr('variant-id-message');
  console.log(selectedVariantMessage);
  if (selectedVariantMessage) {
    $('product-form').addClass('preorder-button');
    $('product-form .preorder-message').hide();
    $('product-form .preorder-message[variant-id="' + selectedVariant + '"]').show();
    $('[name="properties[Null]"]').attr( 'name','properties[Pre-Order]');
    $('#preorder').val(selectedVariantMessage);
  } else {
    $('product-form').removeClass('preorder-button');
    $('product-form .preorder-message').hide();
    $('[name="properties[Pre-Order]"]').attr( 'name','properties[Null]');
    $('#preorder').val(selectedVariantMessage);
  }
});